var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "tv-cal-container" },
    [
      _c("b-alert", { attrs: { show: "", variant: "primary" } }, [
        _vm._v("Today's Calendar")
      ]),
      _c(
        "div",
        [
          _c("b-table", {
            attrs: {
              fields: _vm.todayMsFields,
              items: _vm.moduleSessionList,
              hover: "",
              "current-page": _vm.currentPage,
              "per-page": _vm.perPage,
              "foot-clone": "",
              bordered: "",
              striped: ""
            },
            scopedSlots: _vm._u([
              {
                key: "trainerName",
                fn: function(row) {
                  return [
                    !_vm.showInput
                      ? _c(
                          "span",
                          {
                            on: {
                              click: function($event) {
                                $event.stopPropagation()
                                _vm.showInput = true
                              }
                            }
                          },
                          [
                            _vm._v(
                              _vm._s(row.item.trainerName) +
                                "\n                "
                            )
                          ]
                        )
                      : _vm._e(),
                    _vm.showInput
                      ? _c("b-form-input", {
                          attrs: { type: "text" },
                          nativeOn: {
                            keydown: function($event) {
                              if (
                                !("button" in $event) &&
                                _vm._k(
                                  $event.keyCode,
                                  "enter",
                                  13,
                                  $event.key,
                                  "Enter"
                                )
                              ) {
                                return null
                              }
                              _vm.updateTrainerName(
                                $event,
                                row.item.trainerName,
                                row.item.id
                              )
                            }
                          },
                          model: {
                            value: row.item.trainerName,
                            callback: function($$v) {
                              _vm.$set(row.item, "trainerName", $$v)
                            },
                            expression: "row.item.trainerName"
                          }
                        })
                      : _vm._e()
                  ]
                }
              }
            ])
          }),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { staticClass: "my-1", attrs: { md: "6" } },
                [
                  _c("b-pagination", {
                    staticClass: "my-0",
                    attrs: {
                      "total-rows": _vm.totalRows,
                      "per-page": _vm.perPage
                    },
                    model: {
                      value: _vm.currentPage,
                      callback: function($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage"
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c("br"),
      _c("b-alert", { attrs: { show: "", variant: "secondary" } }, [
        _vm._v("\n        Announcement\n        "),
        _c("br"),
        _vm._v("\n        " + _vm._s(_vm.announcement) + "\n    ")
      ]),
      _c("b-btn", { on: { click: _vm.showInputAnn } }, [
        _vm._v("Edit Announcement")
      ]),
      _c(
        "b-row",
        { staticClass: "hide-input", attrs: { id: "input-ann" } },
        [
          _c("b-form-input", {
            model: {
              value: _vm.announcement,
              callback: function($$v) {
                _vm.announcement = $$v
              },
              expression: "announcement"
            }
          })
        ],
        1
      ),
      _c("p", [_vm._v(_vm._s(_vm.mark))])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5729d5ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5729d5ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tvCalendar.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-5729d5ce","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/tvCalendar.vue
// module chunks = 15